import { render, staticRenderFns } from "./CourseEvaluationCategoryManagementPage.vue?vue&type=template&id=1b610f0d"
import script from "./CourseEvaluationCategoryManagementPage.vue?vue&type=script&lang=js"
export * from "./CourseEvaluationCategoryManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports